import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Testo from "../elementi/Testo";
import {
  monFetch,
  apriAccordion,
} from "../inc/inc";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import PopupElimina from "../elementi/PopupElimina";
import CircularProgress from "@mui/material/CircularProgress";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import AccountTreeIcon from "@mui/icons-material/AccountTree";

import Tooltip from "@mui/material/Tooltip";

const apriSezioniDomanda = (idDomanda) => {
  //apri i box della domanda selezionata
  let dom = document.querySelector(".dom" + idDomanda);
  let sottosez = dom.closest(".boxSottosezione");
  let sez = dom.closest(".boxSezione");

  apriAccordion(sez, "boxSezione", "wrapSottosezione");

  apriAccordion(sottosez, "boxSottosezione", "boxDomande");

  setTimeout(() => {
    dom.scrollIntoView();
    window.scrollBy(0, -100);
  }, 500);

  dom.classList.add("lampeggia");
};

const Comp = (props) => {
  //const ruoloLogin = controllaLogin();

  let location = useLocation();

  let idDomandaSalvata = new URLSearchParams(location.search).get("idDom");

  const [domande, setDomande] = useState([]);

  const [popupElimina, setPopupElimina] = useState(false);
  const [clienteDaEliminare, setClienteDaEliminare] = useState(null);

  const [cercaDomanda, setCercaDomanda] = useState("")
  const [caricato, setCaricato] = useState(null)

  async function query() {
    const res = await monFetch("/questionList", { cercaDomanda });
    // console.log(res);
    setDomande(res.question);
    setCaricato(true)
  }

  async function eliminaCliente(id) {
    const res = await monFetch("/questionDelete", { id });
    // console.log(res);
    setPopupElimina(false);
    window.location.href = process.env.PUBLIC_URL + "/domande";
    // query();
  }

  async function settaOrdinamento($idDomanda, $direzione, $idSezione) {
    //$direzione 1 = porta dopo
    //$direzione 0 = porta prima
    const res = await monFetch("/questionOrder", {
      direction: $direzione,
      question_id: $idDomanda,
      subsection_id: $idSezione,
    });
    query();
  }

  useEffect(() => {
    props.setTestoTitolo(
      <>
        <Button
          variant="contained"
          href={process.env.PUBLIC_URL + "/domanda-nuovo"}
          className="buttonSalva"
          style={{ marginRight: 20 }}
        >
          Nuovo
        </Button>
        Lista Domande
      </>
    );
    query();
  }, []);


  useEffect(() => {
    query();
  }, [cercaDomanda]);

  useEffect(() => {
    console.log(idDomandaSalvata);
    if (domande.length > 0 && idDomandaSalvata) {
      apriSezioniDomanda(idDomandaSalvata);
    }
  }, [domande]);


  if (domande.length == 0 && !caricato) {
    return <CircularProgress />;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Testo
            name="cerca"
            label="Cerca testo domanda"
            value={cercaDomanda || ""}
            onChange={(e) => {
              setCercaDomanda(e.target.value);
            }}
            inputProps={{
              autoComplete: "off"
            }}
          />
        </Grid>
      </Grid>
      <br />
      {domande.map((el, index) => {
        let classeUnivoca = "bsez" + index;
        return (
          <div
            className={"pointer boxSezione boxAccordion " + classeUnivoca}
            key={index}
            onClick={(e) => {
              apriAccordion(
                e.target,
                "boxSezione",
                "wrapSottosezione"
              );
            }}
          >
            <div className="rigaSezione bgColor">
              <FormatListBulletedIcon /> <span>{el.section}</span>
            </div>
            <div className="wrapSottosezione">
              {el.subsection.map((el, index2) => {
                let classeUnivoca = "bsez" + index + "ss" + index2;
                return (
                  <div
                    className={
                      "pointer boxSottosezione boxAccordion " + classeUnivoca
                    }
                    key={index2}
                    onClick={(e) => {
                      e.stopPropagation();
                      apriAccordion(
                        e.target,
                        "boxSottosezione",
                        "boxDomande"
                      );
                    }}
                  >
                    <div className="rigaSottosezione bgColorLight">
                      {el.name}
                    </div>
                    <div className="boxDomande">
                      <Table className="tabellaDomande">
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell></TableCell>
                            <TableCell>Sottosezione</TableCell>
                            <TableCell>Testo domanda</TableCell>
                            <TableCell>Note Interne</TableCell>
                            <TableCell>Note Commerciale</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {el.questions.map((dom, index) => {

                            return (
                              <TableRow
                                key={dom.id}
                                className={"rigaSelezionabile dom" + dom.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.location.href =
                                    process.env.PUBLIC_URL +
                                    "/domanda/" +
                                    dom.id;
                                }}
                              >
                                <TableCell>{dom.order}</TableCell>
                                <TableCell>
                                  {dom.parent_answer_id ? (
                                    <Tooltip
                                      title={
                                        "Apri la domanda che contiene la risposta padre"
                                      }
                                    >
                                      <AccountTreeIcon
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          window.location.href =
                                            process.env.PUBLIC_URL +
                                            "/domanda/" +
                                            dom.parentQuestionId;
                                        }}
                                      />
                                    </Tooltip>
                                  ) : null}
                                </TableCell>
                                <TableCell>{dom.subsectionName}</TableCell>
                                <TableCell className="limitaTesto">
                                  <Tooltip
                                    title={
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: dom.textNoHtml,
                                        }}
                                        style={{ margin: 0 }}
                                      ></div>
                                    }
                                  >
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: dom.textNoHtml,
                                      }}
                                    ></div>
                                  </Tooltip>
                                </TableCell>
                                <TableCell className="limitaTesto">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: dom.internal_note,
                                    }}
                                  ></div>
                                </TableCell>
                                <TableCell className="limitaTesto">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: dom.commercial_note,
                                    }}
                                  ></div>
                                </TableCell>
                                <TableCell>
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      settaOrdinamento(
                                        dom.id,
                                        0,
                                        dom.subsection_id
                                      );
                                    }}
                                  >
                                    <KeyboardArrowUpIcon
                                    // style={{opacity: mostraFrecciaSu ? 1 : 0.4}}
                                    />
                                  </a>
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      settaOrdinamento(
                                        dom.id,
                                        1,
                                        dom.subsection_id
                                      );
                                    }}
                                  >
                                    <KeyboardArrowDownIcon
                                    // style={{opacity: mostraFrecciaGiu ? 1 : 0.4}}
                                    />
                                  </a>
                                </TableCell>
                                <TableCell>
                                  {dom.hasParentAnswers ? (
                                    //disabilito se la risposta è parent di una domanda
                                    <Tooltip
                                      title={
                                        <>
                                          Impossibile eliminare.
                                          <br />
                                          La domanda contiene risposte padri di
                                          altre domande.
                                        </>
                                      }
                                    >
                                      <DeleteIcon
                                        color="error"
                                        style={{
                                          cursor: "pointer",
                                          opacity: 0.4,
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <DeleteIcon
                                      color="error"
                                      style={{
                                        cursor: "pointer",
                                        opacity: 1,
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setPopupElimina(true);
                                        setClienteDaEliminare(dom.id);
                                      }}
                                    />
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      {/* <Table className="tabellaDomande">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Sottosezione</TableCell>
            <TableCell>Testo domanda</TableCell>
            <TableCell>Note Interne</TableCell>
            <TableCell>Note Commerciale</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {domande.map((dom, index) => {
            sezione = dom.sectionName;
            let rigaTitolo = null;
            let cambioSezione = false;
            if (sezione != sezionePrecedente) {
              cambioSezione = true;
              rigaTitolo = (
                <TableRow>
                  <TableCell colSpan={7} className="bgColor">
                    {dom.sectionName}
                  </TableCell>
                </TableRow>
              );
            }
            sezionePrecedente = dom.sectionName;

            // //mostra le frecce per ordinamento
            // let mostraFrecciaSu = true;
            // let mostraFrecciaGiu = true;
            // if (index == 0 || cambioSezione == true) {
            //   mostraFrecciaSu = false;
            // }
            // if (index == (domande.length - 1)) {
            //   mostraFrecciaGiu = false;
            // }
            // //

            return (
              <React.Fragment key={dom.id}>
                {rigaTitolo}
                <TableRow
                  className="rigaSelezionabile"
                  onClick={(e) => {
                    window.location.href = process.env.PUBLIC_URL+"/domanda/" + dom.id;
                  }}
                >
                  <TableCell>{dom.order}</TableCell>
                  <TableCell>{dom.subsectionName}</TableCell>
                  <TableCell className="limitaTesto">
                    <Tooltip
                      title={
                        <div
                          dangerouslySetInnerHTML={{ __html: dom.textNoHtml }}
                          style={{ margin: 0 }}
                        ></div>
                      }
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: dom.textNoHtml }}
                      ></div>
                    </Tooltip>
                  </TableCell>
                  <TableCell className="limitaTesto">
                    <div
                      dangerouslySetInnerHTML={{ __html: dom.internal_note }}
                    ></div>
                  </TableCell>
                  <TableCell className="limitaTesto">
                    <div
                      dangerouslySetInnerHTML={{ __html: dom.commercial_note }}
                    ></div>
                  </TableCell>
                  <TableCell>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        settaOrdinamento(dom.id, 0, dom.subsection_id);
                      }}
                    >
                      <KeyboardArrowUpIcon
                      // style={{opacity: mostraFrecciaSu ? 1 : 0.4}}
                      />
                    </a>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        settaOrdinamento(dom.id, 1, dom.subsection_id);
                      }}
                    >
                      <KeyboardArrowDownIcon
                      // style={{opacity: mostraFrecciaGiu ? 1 : 0.4}}
                      />
                    </a>
                  </TableCell>
                  <TableCell>
                    {dom.hasParentAnswers ? (
                      //disabilito se la risposta è parent di una domanda
                      <Tooltip
                        title={
                          <>
                            Impossibile eliminare.
                            <br />
                            La domanda contiene risposte padri di altre domande.
                          </>
                        }
                      >
                        <DeleteIcon
                          color="error"
                          style={{
                            cursor: "pointer",
                            opacity: 0.4,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        />
                      </Tooltip>
                    ) : (
                      <DeleteIcon
                        color="error"
                        style={{
                          cursor: "pointer",
                          opacity: 1,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPopupElimina(true);
                          setClienteDaEliminare(dom.id);
                        }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table> */}
      <PopupElimina
        open={popupElimina}
        fnAnnulla={(e) => setPopupElimina(false)}
        fnSuccess={(e) => eliminaCliente(clienteDaEliminare)}
      />
    </>
  );
};

export default Comp;
